import request from '@webtrader/core/request';

export interface IBusinessHours {
  dayOfWeek: number;
  from?: string;
  to?: string;
}

export interface ICompanyContact {
  website: string;
  email: string;
  socialMedia: Record<string, string>;
  dialCode: string;
  mobile: number;
  businessHoursTimeZone: string;
  businessHours: IBusinessHours[];
  lastUpdated: Date;
}

const contactAPI = () => request.get<ICompanyContact>('/api/config/v2/company/contact');

export default contactAPI;
